// jl: this should match DealStage enums in deals/constants
export const DEAL_STAGE = {
  INACTIVE: 'inactive',
  EARLY_ACCESS: 'early access',
  GENERAL_ACCESS: 'general access',
  LAST_CALL: 'last call',
};

export default {
  DEAL_STAGE,
};
